(ns common.schema.entities.counterparty-diligence.company.core
  (:require [common.features.plan :as plan]
            [common.schema.entities.counterparty-diligence.company :as company-counterparty-diligence]
            [common.schema.entities.counterparty-diligence.util :as counterparty-diligence-util]))

;; Verbatim copy of common.schema.entity-types's existing
;; company-counterparty-diligence entry (entity_types.cljc:2439-2444, sharing
;; counterparty-diligence-read-check-fn at lines 505-529) - required here,
;; not there, to avoid a circular namespace dependency (entity_types.cljc
;; requires this registry). Keep in sync if the original ever changes.
;;
;; The original check-fn also handles project-counterparty-diligence's
;; source-entity carve-out (light-access users granted access via the
;; project's originating oppo/exit-opportunity) - that branch never applies
;; here since company-counterparty-diligence has no :source-entity field, so
;; it collapses to the simpler admin-only form below.
(defn- read-permissions-check-fn
  [{:keys [tenant tenant-plan role account-current-permissions]}]
  (and (plan/available :feature/counterparty-diligence tenant role tenant-plan)
       (contains? (:account-modules account-current-permissions)
                  :module/counterparty-diligence-admin)))

(def entity-type-definition
  {:entity-type                  :entity.type/company-counterparty-diligence
   :schema                       company-counterparty-diligence/schema
   :name                         {:en "Counterparty Diligence - Company"}
   :plural                       {:en "Company diligences"}
   :icon                         :fa-building-shield
   :create-icon                  :fa-building-shield
   :read-permissions-check-fn    read-permissions-check-fn
   :disable-permissions-check-fn counterparty-diligence-util/admin-delete-check-fn
   ;; No pre-existing legacy dedicated OpenSearch index at all for this
   ;; entity type (unlike fund-commitment/investor) - :search-index? is left
   ;; unset/true below so the generic materialization pipeline creates a
   ;; genuinely new dedicated index via
   ;; backend.search.dedicated.indexes/ensure-index-up-to-date!, same as
   ;; sale-agreement/contract-kyc-profile (see ai/mistakes.md). The last
   ;; default column (:screening-status, the kanban footer field) was
   ;; confirmed accessible for this dev tenant before reusing the legacy
   ;; column list verbatim - no tenant/field-configurations override exists
   ;; for this entity type at all - re-verify live if that ever changes (see
   ;; the fund-commitment kanban header/footer-field entry in
   ;; ai/mistakes.md).
   :search                       {:result/title-attr    :company-counterparty-diligence/company-name
                                  :list/default-columns [:company-counterparty-diligence/company-name
                                                         :counterparty-diligence/status
                                                         :company-counterparty-diligence/template
                                                         :counterparty-diligence/note
                                                         :company-counterparty-diligence/screening-status]
                                  :views {:grid {:po-default-field-paths [[:company-counterparty-diligence/company-name]
                                                                          [:counterparty-diligence/status]
                                                                          [:company-counterparty-diligence/template]
                                                                          [:counterparty-diligence/note]
                                                                          [:company-counterparty-diligence/screening-status]]
                                                 :mandatory-field-paths [[:company-counterparty-diligence/company-name]]}}}})
